<template>
  <v-textarea
    rows="3"
    no-resize
    :label="label"
    v-bind="[defaultProps, $attrs]"
    v-on="$listeners"
  >
    <template #label>
      <slot name="label">
        <span class="input-labels">{{ label }}</span>
        <span v-show="required" class="red--text"> *</span>
      </slot>
    </template>
  </v-textarea>
</template>

<script>
import { defaultPropsInput } from "@/mixins/defaultPropsInput";

export default {
  name: "BaseTextArea",
  inheritAttrs: false,
  props: {
    variant: {
      type: String,
    },
    label: {
      type: String,
      default: "",
    },
    required: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [defaultPropsInput],
};
</script>

<style lang="scss">
.v-window__container {
  width: 100% !important;
}
</style>
